import { appConstants } from '../_constants';
import { initialState } from '../_store/initialState';

export function entityTypes(state=initialState.entityTypes, action) {
    switch (action.type) {
        case appConstants.GET_ENTITIES:
            return action.entities;
        default:
            return state
      }
}



// WEBPACK FOOTER //
// ./src/_reducers/entityTypes.reducer.js